export const ImageIcon = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10_9)">
      <path
        d="M37.5125 34.375C37.5125 36.8614 36.5248 39.246 34.7666 41.0041C33.0085 42.7623 30.6239 43.75 28.1375 43.75C25.6511 43.75 23.2665 42.7623 21.5084 41.0041C19.7502 39.246 18.7625 36.8614 18.7625 34.375C18.7625 31.8886 19.7502 29.504 21.5084 27.7459C23.2665 25.9877 25.6511 25 28.1375 25C30.6239 25 33.0085 25.9877 34.7666 27.7459C36.5248 29.504 37.5125 31.8886 37.5125 34.375Z"
        fill="black"
      />
      <path
        d="M12.5125 6.25C9.19731 6.25 6.01788 7.56696 3.67368 9.91117C1.32947 12.2554 0.0125122 15.4348 0.0125122 18.75V81.25C0.0125122 84.5652 1.32947 87.7446 3.67368 90.0888C6.01788 92.433 9.19731 93.75 12.5125 93.75H87.5125C90.8277 93.75 94.0071 92.433 96.3514 90.0888C98.6956 87.7446 100.013 84.5652 100.013 81.25V18.75C100.013 15.4348 98.6956 12.2554 96.3514 9.91117C94.0071 7.56696 90.8277 6.25 87.5125 6.25H12.5125ZM87.5125 12.5C89.1701 12.5 90.7598 13.1585 91.9319 14.3306C93.104 15.5027 93.7625 17.0924 93.7625 18.75V59.375L70.1563 47.2062C69.5702 46.9126 68.9066 46.8108 68.2594 46.9151C67.6122 47.0194 67.0142 47.3246 66.55 47.7875L43.3625 70.975L26.7375 59.9C26.1373 59.5004 25.4173 59.3206 24.6996 59.3913C23.982 59.4619 23.3108 59.7785 22.8 60.2875L6.26251 75V18.75C6.26251 17.0924 6.92099 15.5027 8.0931 14.3306C9.2652 13.1585 10.8549 12.5 12.5125 12.5H87.5125Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_10_9">
        <rect width="100" height="100" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
